'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = require('./Scrollbars');

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/index.js
// module id = 698
// module chunks = 168707334958949